export const INELIGIBLE_URL = 'vehicle-not-eligible';
export const DAYS_TO_EXPIRE_ENQUIRY = 7;
